import {reqWithToken} from './requestHelper';


export async function getClaimDefinitions() {
    return (await reqWithToken('api/claims')).data;
}

export async function updateClaimDefinition(claim){
    return (await reqWithToken('api/claims',{
        data: claim,
        method: 'put'
    })).data;
}

export async function insertClaimDefinition(claim){
    return (await reqWithToken('api/claims',{
        data: claim,
        method: 'post'
    })).data;
}

export async function deleteClaimDefinition(id){
    return (await reqWithToken('api/claims',{
        params: {id},
        method: 'delete'
    })).data;
}

